import pipe from 'callbag-pipe';
import subscribe from 'callbag-subscribe';

import {ShopifyProduct, ShopifyVariant} from '../../../../../interfaces/shopify-product.interface';
import {ShopifyService} from '../../../../../api/services/shopify.service';
import {OutOfStockComponentView} from './out-of-stock-component.view';
import {Planogram} from '../../../../../planogram';
import {UrlUtils} from '../../../../../api/urls';
import {ShoppingCartService} from '../../../../../api/services/shopping-cart.service';
import {OutOfStockService} from '../../../../../api/services/out-of-stock.service';
import {ShoppingAccount} from '../../../../../shopping-account/account';
import {Metrics} from '../../../../../metrics';
import {MATOMO_EVENT_NAMES} from '../../../../../metric-events';

export class OutOfStockComponent {
  private variant: ShopifyVariant;
  private inputField: HTMLInputElement;
  private notifyMeButton: HTMLElement;
  private inputFieldWrapper: HTMLElement;
  private mainContentContainer: HTMLElement;
  private responseContainer: HTMLElement;
  private agreementContainer: HTMLElement;
  private isAnonymous: boolean = true;
  private outOfStockService: OutOfStockService;
  private readonly selectedProductSubjectRef: Function;

  constructor(
    private planogram: Planogram,
    private mainContainer: HTMLElement,
    private product: ShopifyProduct,
    private shopifyService: ShopifyService,
    private shoppingCartService: ShoppingCartService
  ) {
    this.outOfStockService = new OutOfStockService();

    this.selectedProductSubjectRef = pipe(
      this.shopifyService.selectedProductSubject,
      subscribe({
        next: (variant: ShopifyVariant | undefined) => {
          if (variant) {
            this.variant = variant;
            this.renderComponent();
          }
        }
      })
    );
  }

  private renderComponent() {
    const outOfStockContainer = this.mainContainer.querySelector<HTMLElement>('.app-ecommerce-out-of-stock-container');
    outOfStockContainer.innerHTML = '';

    if (this.variant.inventory_quantity || this.variant.isAutoSelected) {
      return;
    }

    const outOfStock = document.createElement('div');
    outOfStockContainer.append(outOfStock);
    outOfStock.outerHTML = OutOfStockComponentView(this.product);
    this.mainContentContainer = outOfStockContainer.querySelector<HTMLElement>('.app-shopify-out-of-stock-form');
    this.responseContainer = outOfStockContainer.querySelector<HTMLElement>('.app-shopify-out-of-stock-response');
    this.agreementContainer = outOfStockContainer.querySelector<HTMLElement>('.app-shopify-out-of-stock-agreement');
    this.inputFieldWrapper = outOfStockContainer.querySelector<HTMLElement>('.input-field-wrapper');
    this.inputField = outOfStockContainer.querySelector<HTMLInputElement>('#out-of-stock-email');
    this.notifyMeButton = outOfStockContainer.querySelector<HTMLElement>('#notify-me-button');

    this.notifyMeButton.onclick = () => this.handleButtonClicks();
  }

  private async handleButtonClicks() {
    if (this.notifyMeButton.classList.contains('loading')) {
      return;
    }

    if (this.shoppingCartService.getMultipassToken || ShoppingAccount.isLogged) {
      this.isAnonymous = false;
    }

    if (this.isAnonymous && this.inputFieldWrapper.classList.contains('is-hidden')) {
      this.inputFieldWrapper.classList.remove('is-hidden');
      this.agreementContainer.classList.remove('is-hidden');
      return;
    }

    if (this.isAnonymous && !this.inputField.reportValidity()) {
      return;
    }

    Metrics.storeTheEvent(
      this.planogram.name,
      'click',
      MATOMO_EVENT_NAMES.CLICK_ECOMMERCE_OVERLAY_NOTIFY_ME_BUTTON(
        this.product?.identifier,
        UrlUtils.slugify(this.product?.name)
      )
    );
  }

  dispose() {
    this.selectedProductSubjectRef();
  }
}
